// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__POj5b","checkbox":"Checkbox_checkbox__Dj9TD"};